<template>
    <v-container fluid>
         <div v-if="!loading">
            
            <v-row class="my-2 subtitle-2 secondary--text pl-12">
                Brand loyalty
            </v-row>
            <v-divider />
            <div v-if="loyalty.length > 0">
                <!--table head-->
                <v-row class="subtitle-2" no-gutters>
                    <v-col class="tabCell text-left">Trademark / Segment</v-col>
                    <v-col v-for="(segment, i) in segments" :key="i" class="tabCell text-center">
                        {{ segment.name }}
                    </v-col>
                </v-row>
            
                <!--loyalty tab-->
                <v-row v-for="trademark in trademarks" :key="trademark.i" no-gutters>
                    <v-col class="tabCell text-left">{{ trademark.name }}</v-col>
                    <v-col v-for="(segment, i) in segments" :key="i" class="tabCell text-center">
                        {{ getLoyalty(segment.id, trademark.id) }}
                    </v-col>
                </v-row>
            </div>
            <v-row v-else class="mt-8 px-4" justify="center">
                You haven't loyalty yet!
            </v-row>
        </div>
        <!--!loading-->
        <div v-else class="text-center">
            <loader></loader>
        </div>
    </v-container>
</template>
<script>
import { roundNumber } from '../../../functions/common';
import Loader from '../../../layouts/Loader.vue';
export default {
    name: 'BrandLoyalty',
    data() {
        return {}
    },
    computed: {
        loading() {
            return this.$store.getters.loading;
        },
        locale() {
            return this.$store.getters.locale;
        },
        loyalty() {
            return this.$store.getters.loyalty;
        },
        segments() {
            let res = [];
            if (this.loyalty.length > 0) {
              this.loyalty.map((item) => {
                const inArr = res.find((it) => it.id == item.segment.id)
                if (!inArr) {
                    res.push({ id: item.segment.id,
                        name: item.segment.name });
                }
                });  
            }
            return res;
        },
        trademarks() {
            let res = [];
            if (this.loyalty.length > 0) {
              this.loyalty.map((item) => {
                const inArr = res.find((it) => it.id == item.trademark.id)
                if (!inArr) {
                    res.push({ id: item.trademark.id,
                        name: item.trademark.name });
                }
                });  
            }
            return res;
        }
    },
    methods: {
        getLoyalty(segmentId, trademarkId) {
            let line = this.loyalty.find((item) => item.segmentId == segmentId && item.trademarkId == trademarkId);
            let res = line ? roundNumber(line.loyalty, 2) : 0;
            return res;
        }
    },
    components: { Loader }
}
</script>